import { ConfigProvider } from 'antd';
import { AssessmentAPIUseCaseInterface } from 'application/usecases/AssessmentUseCase';
import { AuctionBidsAPIUseCaseInterface } from 'application/usecases/AuctionBidsUseCase';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { TestUseCaseInterface } from 'application/usecases/TestUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import AppTheme from 'assets/styles/common/theme';
import Router from 'presentation/router/Router';
import './App.css';
import { UaGate } from './UaGate';
import jaJP from 'antd/locale/ja_JP';
import { ChatUseCase } from 'application/usecases/ChatUseCase';
import { FileUseCaseInterface } from 'application/usecases/FileUseCase';
import { NotifyUseCase } from 'application/usecases/NotifyUseCase';
import { PurchaseUseCaseInterface } from 'application/usecases/PurchaseUseCase';
import 'dayjs/locale/ja';

export interface AppProps {
    authUseCase: AuthUseCaseInterface;
    testUseCase: TestUseCaseInterface;
    userStorageUseCase: UserStorageUseCaseInterface;
    userUseCase: UserUseCaseInterface;
    propertyUseCase: PropertyUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
    assessmentUseCase: AssessmentAPIUseCaseInterface;
    auctionBidsUseCase: AuctionBidsAPIUseCaseInterface;
    simulateUseCase: SimulateUseCaseInterface;
    purchaseUseCase: PurchaseUseCaseInterface;
    fileUseCase: FileUseCaseInterface;
    notifyUseCase: NotifyUseCase;
    chatUseCase: ChatUseCase;
}

function App(appProps: AppProps) {
    
    return (
        <div translate="no">
            <ConfigProvider theme={AppTheme} locale={jaJP}>
                 <UaGate>
                    <Router {...appProps} />
                </UaGate>
            </ConfigProvider>
        </div>
    );
}

export default App;
